import { useCallback, useEffect, useState } from 'react'

import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs'
import { CurrenciesTab } from './CurrenciesTab'
import { GroupsTab } from './GroupsTab'
import { PaymentProvidersTab } from './PaymentProvidersTab'
import { Currency } from '../../../common/models'
import { useTableParams } from '../../../core/hooks/table-params'
import { getCurrencies } from '../../../core/services/festival-settings'
import { Button, Card } from '@/components/ui'
import { Header, PageTitle } from '@/components'
import { Icon } from '@/common/components/Icon'
import { useNavigate } from 'react-router'

type GroupType = 'fg' | 'cu' | 'pp'

export const GroupsPage: React.FC = (): JSX.Element => {
  const [key, setKey] = useState<GroupType>('fg')
  const { setExtraParams } = useTableParams({
    extraParams: {
      key: 'fg',
    },
    onlyExtraParams: true,
  })

  const [currencies, setCurrencies] = useState<Currency[]>([])
  const navigate = useNavigate()

  const init = useCallback(async () => {
    try {
      const { status, data } = await getCurrencies()
      if (status === 200) {
        setCurrencies(data.currencies)
      }
    } catch (err) {
      console.log(err)
    }
  }, [])

  useEffect(() => {
    init()
  }, [init])

  return (
    <>
      <Header pageTitle="Groups" breadcrumbs={['Global Settings', 'Groups']} />
      <div className="flex flex-row items-center justify-between gap-3 mb-5 w-full">
        <Button variant="secondary" onClick={() => navigate(-1)}>
          <Icon
            icon="arrow-left"
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
          />
          Back
        </Button>
        <span className="text-title-s text-monochrome-1">
          Groups Configuration
        </span>
        <div className="min-w-[82px]" />
      </div>
      <Tabs
        value={key}
        onValueChange={(value) => {
          setKey(value as GroupType)
          setExtraParams((s) => ({ ...s, key: value }))
        }}
      >
        <TabsList className="grid w-full mb-2">
          <div className="bg-white/10 p-2.5 rounded-[20px]">
            <TabsTrigger value="fg">Festival Groups</TabsTrigger>
            <TabsTrigger value="cu">Currencies</TabsTrigger>
            <TabsTrigger value="pp">Payment Providers</TabsTrigger>
          </div>
        </TabsList>
        <div className="max-h-[calc(100vh-280px)] overflow-y-auto">
          <TabsContent value="fg">
            <GroupsTab currencies={currencies} />
          </TabsContent>
          <TabsContent value="cu">
            <CurrenciesTab />
          </TabsContent>
          <TabsContent value="pp">
            <PaymentProvidersTab />
          </TabsContent>
        </div>
      </Tabs>
    </>
  )
}
